import { Button } from '@front10/landing-page-book/dist/components';
import styled from 'styled-components';

const OrangeButton = styled(Button)`
  background: var(--bl-orange) !important;
  color: white !important;
  font-weight: bold !important;
  border: none;

  padding: 0;
  box-shadow: 0 1px 24px 0 var(--bl-yellow), 0 1px 6px 0 #f9bb40;

  transition: all 0.3s ease;
  padding: 8px 16px;

  &:hover {
    background: var(--bl-yellow-dark) !important;
  }
`;

export default OrangeButton;
